<template>
  <div>
    <!-- <el-card class="ibox">
          <div slot="header" class="clearfix flex justify-between">
            <h5>查询条件</h5>
          </div>
          <div class="card-body">
        
          </div>
        </el-card> -->

    <el-card class="ibox">
      <div slot="header" class="clearfix flex justify-between">
        <div>开户行信息</div>
        <div class="card-header-right">
          <el-button v-if="accountBankManageInfo.returnFlag == '1'" type="default" size="small" @click="_goBack()">
            返回
          </el-button>
          <el-button type="primary" size="small" @click="_openAddAccountBankModal()">
            <i class="el-icon-plus"></i>添加
          </el-button>
        </div>
      </div>
      <div class="card-body">
        <el-table :data="accountBankManageInfo.accountBanks" style="width: 100%" border>
          <el-table-column prop="bankId" label="银行编号" align="center">
          </el-table-column>
          <el-table-column prop="bankCode" label="银行账号" align="center">
          </el-table-column>
          <el-table-column prop="personName" label="持卡人" align="center">
          </el-table-column>
          <el-table-column prop="personTel" label="手机号" align="center">
          </el-table-column>
          <el-table-column prop="bankName" label="开户行" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" @click="_openEditAccountBankModel(scope.row)">
                  修改
                </el-button>
                <el-button size="mini" @click="_openDeleteAccountBankModel(scope.row)">
                  删除
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next, jumper" :total="accountBankManageInfo.total" class="pagination">
        </el-pagination>
      </div>
    </el-card>

    <add-account-bank ref="addAccountBank" @refresh="query()"></add-account-bank>
    <edit-account-bank ref="editAccountBank" @refresh="query()"></edit-account-bank>
    <delete-account-bank ref="deleteAccountBank" @refresh="query()"></delete-account-bank>
  </div>
</template>

<script>
import { queryAccountBank } from '@/api/goods/accountBankApi'
import AddAccountBank from '@/components/goods/addAccountBank/AddAccountBank'
import EditAccountBank from '@/components/goods/editAccountBank/EditAccountBank'
import DeleteAccountBank from '@/components/goods/deleteAccountBank/DeleteAccountBank'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AccountBankManage',
  components: {
    AddAccountBank,
    EditAccountBank,
    DeleteAccountBank
  },
  data() {
    return {
      accountBankManageInfo: {
        accountBanks: [],
        total: 0,
        records: 1,
        moreCondition: false,
        returnFlag: '',
        conditions: {
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.accountBankManageInfo.returnFlag = this.$route.query.returnFlag
    this.accountBankManageInfo.conditions.shopId = getShopId()
    this._listAccountBanks(this.currentPage, this.pageSize)
  },
  methods: {
    query() {
      this.currentPage = 1
      this._listAccountBanks(this.currentPage, this.pageSize)
    },
    _listAccountBanks(page, rows) {
      this.accountBankManageInfo.conditions.page = page
      this.accountBankManageInfo.conditions.row = rows
      queryAccountBank(this.accountBankManageInfo.conditions)
        .then(response => {
          this.accountBankManageInfo.total = response.total
          this.accountBankManageInfo.records = response.records
          this.accountBankManageInfo.accountBanks = response.data
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAccountBanks(val, this.pageSize)
    },
    _openAddAccountBankModal() {
      this.$refs.addAccountBank.open()
    },
    _openEditAccountBankModel(accountBank) {
      this.$refs.editAccountBank.open(accountBank)
    },
    _openDeleteAccountBankModel(accountBank) {
      this.$refs.deleteAccountBank.open(accountBank)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-header-right {
  float: right;
  padding: 3px 0;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>